import { i18n } from '@/i18n';
import type { TestConfig } from 'yup';
import * as yup from 'yup';
import { MIN_IMAGES_COUNT } from '@/views/gallery/artworks/constants';
import { validationMessages } from '@/views/gallery/validation-messages';
import { isImageFormatByExtension } from './imageUtils';
import artworksMessages from '@/views/gallery/artworks/artworks.messages';

const { t } = i18n.global;

export const requiredString = yup.string().required(validationMessages.required);
export const requiredNumber = yup
  .number()
  .required(validationMessages.required)
  .typeError(t('platform.app.validation.number'));
export const imageAmountValidation = yup
  .array()
  .min(MIN_IMAGES_COUNT, t('platform.app.validation.minUpload', { minUploadImages: MIN_IMAGES_COUNT }))
  .test('if first item is an image', (value, ctx) => {
    if (Array.isArray(value) && value[0] && !isImageFormatByExtension(value[0].url)) {
      return ctx.createError({ message: artworksMessages.firstItemMustBeAnImage });
    }
    return true;
  });

export const numberOfDecimalsValidationTest: TestConfig<number | undefined | null> = {
  name: 'maxDigitsAfterDecimal',
  message: t('platform.app.validation.maxDigitsAfterDecimal'),
  test: (number) => (number ? /^\d+(\.\d{1,2})?$/.test(number.toString()) : true),
};

export const productPriceValidation = yup
  .number()
  .optional()
  .nullable()
  .moreThan(0, t('platform.app.validation.greaterThan', { minValue: 0 }))
  .test(numberOfDecimalsValidationTest);
